import { useCallback, useEffect, useState } from "react";
import "./index.styl";
import { Image, Button, message, Input } from "antd";
import { useNavigate } from "react-router";
import { routerPath } from "../../router/config";
import { mockData } from "../../router/config";
import { getLoginInfo } from "../../api/login";
import { UserOutlined } from "@ant-design/icons";
import {
  setLocalStorageMultipleItems,
  STORAGE_KEY,
  getStorageValByKey,
} from "../../utils/storage";
import { generatePermissionList } from "../../utils/permisson";

export default function Login() {
  const [account, setAccount] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const onAccountChanged = useCallback((e) => {
    setAccount(e.target.value);
  }, []);
  const onPasswordChanged = useCallback((e) => {
    setPassword(e.target.value);
  }, []);

  useEffect(() => {
    setAccount(getStorageValByKey(STORAGE_KEY.account));
    setPassword(getStorageValByKey(STORAGE_KEY.passwod));
  }, []);

  const onLoginBtnClicked = useCallback(async () => {
    const loginData = await getLoginInfo({
      pwd: password,
      user_name: account,
    });

    console.log("loginData+++:", loginData);
    if (loginData.code == 0 && loginData?.data?.token_info) {
      const { token } = loginData.data;
      const { user_name, permissions, user_no } = loginData.data.token_info;
      const permissionIdList = generatePermissionList(permissions);
      if (permissionIdList && permissionIdList.length < 1) {
        message.error("该用户没有开启菜单权限请联系管理员");
        return;
      }
      setLocalStorageMultipleItems({
        [STORAGE_KEY.token]: token,
        [STORAGE_KEY.nickName]: user_name,
        [STORAGE_KEY.permissionList]: permissionIdList,
        [STORAGE_KEY.account]: account,
        [STORAGE_KEY.passwod]: password,
        [STORAGE_KEY.userNo]: user_no,
      });
      navigate(routerPath.smartBeansSearch);
    } else {
      message.error("登录失败！");
    }
  }, [account, password]);
  return (
    <div
      className="loginContainer"
      style={{
        backgroundImage: `url(${require("../../assets/images/login/login_bg.jpg")})`,
      }}
    >
      <div className="contentContainer">
        <div className="leftPartContainer">
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "flex-end",
              justifyContent: "flex-end",
            }}
          >
            <span style={{ fontWeight: "bold", fontSize: 24 }}>欢迎登录</span>
            <span
              style={{
                display: "inline-block",
                marginBottom: 2,
                paddingLeft: 20,
                fontSize: 16,
                color: "rgb(180, 180, 180)",
              }}
            >
              智慧豆管理后台
            </span>
          </div>
          <div className="title">密码登录</div>
          <div className="inputContainer" style={{ marginTop: 20 }}>
            <Input
              value={account}
              onChange={onAccountChanged}
              size="large"
              style={{ width: 300, height: 50, borderRadius: 4 }}
              placeholder="请输入帐号"
              // prefix={<UserOutlined />}
            />
            {/* <input
              value={account}
              onChange={onAccountChanged}
              style={{
                width: 200,
                borderTop: "none",
                borderRight: "none",
                borderLeft: "none",
                borderRadius: 0,
                outline: "none",
                borderWidth: 1,
              }}
            /> */}
          </div>
          <div className="inputContainer" style={{ marginTop: 20 }}>
            <Input.Password
              value={password}
              onChange={onPasswordChanged}
              size="large"
              style={{ width: 300, height: 50, borderRadius: 4 }}
              placeholder="请输入密码"
            />
            {/* <input
              value={password}
              onChange={onPasswordChanged}
              hoverBorderColor=""
              activeBorderColor="none"
              activeShadow="none"
              className="input"
              style={{
                width: 200,
                borderTop: "none",
                borderRight: "none",
                borderLeft: "none",
                borderRadius: 0,
                outline: "none",
                borderWidth: 1,
                ":focus": {
                  borderColor: "red !important",
                  outline: "none",
                },
              }}
            /> */}
          </div>
          <Button
            disabled={!account || !password}
            onClick={onLoginBtnClicked}
            type="primary"
            style={{ width: 300, height: 60, marginTop: 50, fontSize: 20 }}
          >
            登录
          </Button>
        </div>
      </div>
      <img
        style={{ position: "absolute", top: 50, left: 50 }}
        width="52px"
        height="52px"
        src={require("../../assets/images/common/logo.png")}
        alt="logo"
      />
    </div>
  );
}
